module.exports = __webpack_public_path__ + "img/arrow-up-short.fec76a12.svg";